import { useState, useRef, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import NotificationAlert from "react-notification-alert";
import Notify from "../../lib/Utils/Alert";
import Supplier from "../../lib/Core/Backend/Controllers/Supplier";
import PurchaseOrder from "lib/Core/Backend/Controllers/PurchaseOrder";
import ReactNotificationAlert from "react-notification-alert";

//assets
import { ReactComponent as UploadIcon } from "../../assets/img/upload.svg";
import * as modalCSVcss from "./css/modalUploadCSV.module.css";
import okIMG from "../../assets/img/ok.png";

const ModalUploadCSVTwo = ({ toggle, modal, token, uploadJson, setCallApi,callApi }) => {
  const supplierCtl = useMemo(() => new Supplier(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const alert = useRef(null);
  const file = useRef(null);
  const [fileCsv, setFileCsv] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false); // new state variable

  const uploadHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "text/csv") {
        setFileCsv(file);
      } else {
        Notify(alert, "warning", "This file is not a .csv");
      }
    }
  };

  const resetInfo = () => {
    setFileCsv(null);
  };

  const uploadFile = async () => {
    if (!fileCsv) {
      Notify(alert, 'danger', 'Please select a CSV file');
      return;
    }
    setIsProcessing(true); // set isProcessing to true when the upload starts
    supplierCtl.uploadFile(fileCsv, uploadJson, (data) => {
      setIsProcessing(false); // set isProcessing to false when the upload completes
      if (data?.status === 403) {
        Notify(alert, "danger", "Access denied");
        return;
      }
      if (data.Message === "OK") {
         Notify(alert, "success", "File uploaded successfully");
        resetInfo();
        toggle();
        setCallApi(true); // Update callApi when upload is successful
      } else {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
    });
  };

  const downloadFile = (data, filename) => {
    const csvData = convertToCSV(data);
    const url = window.URL.createObjectURL(new Blob([csvData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(',');
    const rows = data.map(obj => Object.values(obj).join(','));
    return `${header}\n${rows.join('\n')}`;
  };

  const downloadCSVFile = () => {
    purchaseOrderCtl.downloadNonApiOrder(uploadJson.name, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, 'danger', data.errorMessage ?? data.error);
      } else {
        downloadFile(data, `${uploadJson.name}.csv`);
        Notify(alert, 'success', 'Order csv has been downloaded');
      }
    });
  };

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={() => { toggle(); resetInfo(); }}
        backdrop="static"
        centered={true}
        size="lg"
      >
        <ModalHeader toggle={() => { toggle(); resetInfo(); }} className="custom_header_colourTwo">
          Upload CSV
        </ModalHeader>
        <ModalBody>
          <ReactNotificationAlert ref={alert} />
          <div className={modalCSVcss.container}>
            <div className="text">
              <p>Please select a file of type CSV and press send.</p>
            </div>
            <label htmlFor="file" className={modalCSVcss.formContainer}>
              <UploadIcon />
              <span>File Upload CSV</span>
              <input
                type="file"
                name=""
                id="file"
                className={modalCSVcss.dn}
                onChange={uploadHandler}
                ref={file}
                accept=".csv"
              />
            </label>
            {fileCsv?.name && (
              <div className={modalCSVcss.fileSelected}>
                <p>
                  {fileCsv.name}{" "}
                  <span className="arrow">
                    <img src={okIMG} alt="" />
                  </span>
                </p>
              </div>
            )}
            {isProcessing && (
              <div className="d-flex align-items-center">
                <p className="mr-2 mb-0 font-weight-bold">Order is processing</p>
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
          <p
            className="dbuttonc"
            style={{
              color: "#2665F2",
              fontWeight: "900",
              cursor: "pointer",
              fontSize: "18px",
            }}
            
            onClick={downloadCSVFile}
          >
            Download Template
          </p>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={() => { toggle(); resetInfo(); }}>
            Close
          </button>
          {isProcessing ? (
            <button className="btn btn-primaryTwo" disabled>
              Send
            </button>
          ) : (
            <button className="btn btn-primaryTwo" onClick={uploadFile}>
              Send
            </button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalUploadCSVTwo;
